import { NgModule } from '@angular/core';

import { ChatDashboardModule } from './dashboard/dashboard.module';
import { ChatMessageModule } from './message/message.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [MatIconModule],
  exports: [ChatDashboardModule, ChatMessageModule]
})
export class ChatModule {}
